import { Paper, Text, Flex } from '@mantine/core';
import { IconCheck, IconEyeOff } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type ReviewedBadgeProps = {
  isReviewed: boolean;
};

export function ReviewedBadge({ isReviewed }: ReviewedBadgeProps) {
  const config = isReviewed
    ? {
        label: 'Reviewed',
        bg: 'success.1',
        color: 'success.9',
        Icon: IconCheck,
      }
    : {
        label: 'Not reviewed',
        bg: 'warning.2',
        color: 'orange.8',
        Icon: IconEyeOff,
      };

  const { label, bg, color, Icon } = config;

  return (
    <Paper radius={8} py="xxxs" pr="xs" bg={bg} w="fit-content">
      <Flex align="center">
        <Flex px="xxs">
          <Icon size={20} color={`var(--mantine-color-${color.replace('.', '-')})`} />
        </Flex>
        <Text size="sm" fw={FONT_WEIGHTS.medium} c={color}>
          {label}
        </Text>
      </Flex>
    </Paper>
  );
}
